export const esES = {
  NBA_LIST: {
    CREATE_BUTTON: 'Crear um nuevo camino'
  }
};

export default esES;
